export default __webpack_public_path__ + "static/media/location.4649c9f7.jpg";